import { render, staticRenderFns } from "./ImgView.vue?vue&type=template&id=2017c33e&scoped=true&"
import script from "./ImgView.vue?vue&type=script&lang=js&"
export * from "./ImgView.vue?vue&type=script&lang=js&"
import style0 from "./ImgView.vue?vue&type=style&index=0&id=2017c33e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017c33e",
  null
  
)

export default component.exports